// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const body = "Overview__body__KtNWk font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const bold = "700";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const overview = "Overview__overview__Khbjt";
export const regular = "400";
export const sans = "'sans'";
export const section = "Overview__section__e1zmS";
export const semibold = "600";
export const serif = "'serif'";
export const title = "Overview__title__RVOu6";